import { useStorage } from '@funtech-int/web-toolkit';

import { Option } from '@/scenarios/legacy-player/components/PlayerSkin/parts/OptionList';
import { AUTO_QUALITY_VALUE } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Settings/hooks/use-auto-quality-options';
import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';

import { setPreferredUserVideoQuality } from '../../../../utils/preferred-user-video-quality';

export function useChangeQuality() {
    const storage = useStorage();

    return useInstanceCallback((instance, qualityOption: Option<string>) => {
        if (!instance) {
            return;
        }

        if (qualityOption.value === AUTO_QUALITY_VALUE) {
            instance.setVideoTrack();
            return;
        }

        const videoTrack = instance?.videoTracks?.find(
            ({ value }) => value === qualityOption.value
        );

        if (videoTrack) {
            instance.setVideoTrack(videoTrack);
            setPreferredUserVideoQuality(storage, videoTrack.width);
        }
    });
}
